// extracted by mini-css-extract-plugin
module.exports = {"bm-card-source":"bm-card-source","related":"related","no-image":"no-image","source":"source","bm-topic-header":"bm-topic-header"};